
// Application code to be called everytime the body is changed.
// Currently being called when turbolinks replaces the body.
import Validator from './validators';
import Favicon from './favicon';
import ReactRailsUJS from './lib/react-rails';
import GoogleAnalytics from './google_analytics';

const UnionJsFramework = {
  loaded: false,

  initialize() {
    new GoogleAnalytics();

    // Connect "Other" text field for radio or checkbox collections
    $('input[type=text][data-other]').each(function() {
      const $other = $(this);
      const radioId = $other.data('other');
      const $radio = $(`#${radioId}`);

      // Hide the "Other" text field until user clicks the radio
      if (!$radio.is(':checked')) $other.hide();
      $radio.on('click', () => $other.toggle().focus());
    });

    // Prevent enter from triggering from submits on react widgets
    function preventEnterKeySubmit(e) {
      if (e.which === 13) {
        e.preventDefault();
      }
    }

    $('form').on('keydown', '.rw-widget input', preventEnterKeySubmit);

    // Prevent anchor from being added to the URL when a topbar menu is clicked
    $(".Topbar a[href='#']").click(e => e.preventDefault());

    // FIXME Since Firefox and IE don't support `input:checked:after`, this workaround
    // adds a class to the label itself. We go over all inputs because of radio groups.
    // This is a temporary hack.
    const addCheckedClassToLabels = function() {
      $('input[type=radio], input[type=checkbox]').each(function() {
        const $this = $(this);
        if ($this.is(':checked')) $this.closest('label').addClass('is-checked');
        else $this.closest('label').removeClass('is-checked');
      });
    };
    addCheckedClassToLabels();
    $('.checkbox, .radio').on('click', addCheckedClassToLabels);

    $('.Button[data-disableable=true]').removeAttr('disabled');

    $('.Button[data-disableable]').off('click:disableable');
    $('.Button[data-disableable]').on('click:disableable', function(e) {
      let message;

      if ($(this).data('disable-message')) {
        message = $(this).data('disable-message');
      } else {
        message = 'Submitting...';
      }

      const width = $(this).width();

      $(this).attr('disabled', true);
      $(this).width(width);
      // Change both val and text to make method function for both buttons and links
      $(this).val(message);
      $(this).text(message);

      // If this is a form, we prevent the default action, and submit it manually
      // If it's not a form, we don't prevent the default action
      if (this.form) {
        e.preventDefault();
        if ($(this).data('confirm')) {
          const confirmed = confirm($(this).data('confirm'));
          if (confirmed) {
            $(this.form).trigger('submit.rails');
          }
        } else {
          $(this.form).trigger('submit.rails');
        }
      }
    });
    // Client-side validations
    new Validator();

    // Custom favicon per community
    new Favicon();

    // Connect "Other" text field for select menus
    const toggleSelectOtherInput = function(select, focus = true) {
      const $select = $(select || this);
      const selectId = $select.attr('id');
      const selectVal = $select.val();
      const $input = $(`input[type=text][data-select-other=${selectId}_${selectVal}]`);

      // Hide the text fields until user selects the option
      $('input[type=text][data-select-other]').hide();

      if ($input) {
        $input.show();
        if (focus) $input.focus();
      }
    };
    $('form').on('change', 'select[data-select-other]', function() {
      toggleSelectOtherInput(this);
    });
    $('select[data-select-other]').each(function() {
      toggleSelectOtherInput(this, false);
    });
  },

  // Application code to be called on first request
  // Calls `initialize` internally.
  start() {
    if (Union.loaded) {
      Union.initialize();
      return;
    }
    Union.loaded = true;

    // Hide notifications on click
    $(document).on('click', '[data-dismissable]', function() {
      $(this).remove();
    });

    $(window).bind('popstate', e => {
      const state = e.originalEvent.state;
    });

    Union.initialize();
  },

  // Currently being called automatically for all successfull ajax requests.
  // Calls `initialize` internally.
  update() {
    Union.initialize();

    // Make sure react components are mounted after a modal is open (may have ajax content)
    ReactRailsUJS.mountComponents();
  },

  resizeIframe(obj) {
    obj.style.display = 'block';
    obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
    $('#email-preview-loading').hide();
  },
};

export default UnionJsFramework;
